import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as routes from "../../routes";
import { resetInactivityTimer } from "../../services/inactivityTimer";
import { Box, Link } from "@material-ui/core";

import "./Navigation.css";

const Navigation = () => {
    const { t } = useTranslation();
    const account = useSelector(state => state.authentication.account);
    //const enableEmbeddedPowerBi = useSelector(state => state.configuration.enableEmbeddedPowerBi);
    resetInactivityTimer();
    return (
        <Box component="nav" className="navigator">
            <Link component={NavLink} to={routes.DEFAULT} exact>
                {t("Menu.home")}
            </Link>
            <Link component={NavLink} to={routes.ABOUT}>
                {t("Menu.about")}
            </Link>
            {account ? (
                <Link component={NavLink} to={routes.CONTROL_PANEL_UPGRADE}>
                    {t("Menu.controlPanelUpgrade")}
                </Link>
            ) : null}
            {(
                <Link component={NavLink} to={routes.EMBEDDED_POWER_BI}>
                    {t("Menu.embeddedPowerBi")}
                </Link>
            )}
        </Box>
    );
};

export default Navigation;
